import { createFileRoute, } from '@tanstack/react-router';
export const Route = createFileRoute('/client/account/')({
    beforeLoad() {
        throw Route.redirect({
            to: './invoice',
            replace: true,
        });
    },
});
//# sourceMappingURL=index.js.map